import { render, staticRenderFns } from "./AdminPuzzleList.vue?vue&type=template&id=cd79d4b2"
import script from "./AdminPuzzleList.vue?vue&type=script&lang=js"
export * from "./AdminPuzzleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports